/*
 * Hoy: la cola es el producto. Cuatro grupos, siempre en este orden, calculados
 * en el servidor. Cada línea dice qué, de qué cuenta, por qué está aquí y a dónde
 * lleva. Vacío es un buen día, no un estado que haya que disculpar.
 */

import { Link, useNavigate } from "react-router-dom";

import { useHoy } from "../api/hooks";
import { Esqueleto, Punto, fmtFechaLarga } from "../ui/primitivas";

export function Hoy() {
  const nav = useNavigate();
  const { data, isLoading, error } = useHoy();
  const total = data?.grupos.reduce((n, g) => n + g.items.length, 0) ?? 0;
  return (
    <div className="pagina" style={{ maxWidth: 900 }}>
      <header style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", marginBottom: 24 }}>
        <h1 className="titulo">Hoy</h1>
        <span style={{ color: "var(--muted)", fontSize: 13 }}>{data ? fmtFechaLarga(data.fecha) : ""}</span>
      </header>
      {isLoading && <div className="tarjeta"><Esqueleto lineas={4} /></div>}
      {error && <div className="abierto" style={{ padding: "12px 14px", fontSize: 13.5 }}>No se pudo leer la cola: {(error as Error).message}</div>}
      {data && total === 0 && (
        <div className="tarjeta" style={{ fontSize: 14, color: "var(--muted)" }}>
          Nada pendiente. Buen momento para prospectar: <Link to="/cuentas?etapa=sin_contactar">las cuentas sin contactar →</Link>
        </div>
      )}
      {data?.grupos.map((g) => (
        <section key={g.id} style={{ marginBottom: 22 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", padding: "0 4px 8px" }}>
            <h2 className="seccion-h">{g.titulo}</h2>
            <span className="mono" style={{ color: "var(--faint)" }}>{g.items.length}</span>
          </div>
          <div className="lista">
            {g.items.length === 0 && <div style={{ padding: "12px 18px", color: "var(--faint)", fontSize: 13 }}>—</div>}
            {g.items.map((it, i) => (
              <button key={i} onClick={() => nav(it.ir)} className="fila-hover"
                style={{ display: "grid", gridTemplateColumns: "8px minmax(0,1fr) auto", gap: 12, alignItems: "start", width: "100%", padding: "11px 18px", transition: "background 100ms" }}>
                <Punto estado={it.estado} />
                <span style={{ minWidth: 0 }}>
                  <span style={{ display: "flex", gap: 8, alignItems: "baseline", flexWrap: "wrap" }}>
                    <span style={{ fontSize: 14, fontWeight: 500 }}>{it.titulo}</span>
                    <span style={{ fontSize: 12.5, color: "var(--muted)" }}>{it.empresa}</span>
                  </span>
                  <span style={{ display: "block", fontSize: 12.5, color: "var(--muted)", marginTop: 1 }}>{it.sub}</span>
                </span>
                <span style={{ display: "flex", alignItems: "center", gap: 10, whiteSpace: "nowrap" }}>
                  {it.meta && <span className="mono" style={{ color: it.meta.includes("atraso") ? "var(--risk)" : it.meta === "Vence hoy" ? "var(--proposed)" : "var(--muted)" }}>{it.meta}</span>}
                  <span style={{ color: "var(--sky)", fontSize: 13, fontWeight: 500 }}>→</span>
                </span>
              </button>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
